// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

// Note: StrictMode is disabled to avoid double-rendering in dev.
// To enable for testing, wrap <App /> in <React.StrictMode>.
const container = document.getElementById("root");
createRoot(container).render(<App />);